import type { LanguageCode } from "config/languages";
import type { Currencies, CurrenciesConfig } from "config/currencies";
import { nonEURlanguages, euroSign, defaultCurrency } from "../currencies";

export const getCurrencyFromLanguage = (
  language: LanguageCode,
  config = nonEURlanguages as CurrenciesConfig,
  currency = defaultCurrency as Currencies
) => config[language] ?? currency;

export const getCurrencyFormatException = (value: number, language: string) =>
  ({
    bg: `${value} ${euroSign}`,
    hu: `${value} ${euroSign}`,
    "ro-md": `${value} ${euroSign}`,
  }[language]);
